<template>
  <div class="post__user">

    <template v-if="withHeading">
        <div class="post__aside-heading">
            {{$store.getters.t('blog_post_user_author')}}
        </div>
    </template>

    <div class="post__user-body d-flex flex-column align-items-center px-2 pt-3">
        <a :href="profile" class="rounded-circle overflow-hidden mb-3">
            <img :src="avatar" alt="">
        </a>
        <div v-text="name" class="mb-1"></div>
        <div class="mb-4 post__user-text"><span>{{$store.getters.t('blog_post_user_on_site_since')}} </span>{{ createdAt }}</div>
        <a class="btn" href="">{{$store.getters.t('blog_post_user_profile')}}</a>
    </div>

  </div>
</template>

<script>
export default {
    name: "PostUser",
    props: {
        user: { required: true, type: Object },
        withHeading: { required: false, default: true }
    },

    computed: {
        createdAt(){
            return ((this.user.created_at.split('T'))[0]).split('-').reverse().join('.')
        },
        name(){
            return this.user.name
        },
        profile(){
            const { id }  = this.user
            return `/user/${id}/profile`
        },
        avatar(){
            if(this.user.avatar) {
                let { path } = this.user.avatar
                return `/storage/${path.replace('original', 'avatar')}`
            }

        }
    }

}
</script>
